/** @internal */
export class DataLayerAdapter {
    static instance;
    layer;
    constructor() {
        /* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment */
        this.layer = window?.digitalData ?? DataLayerAdapter.initializeDataLayer();
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new DataLayerAdapter();
        }
        return this.instance;
    }
    getDataLayer() {
        return this.layer;
    }
    static initializeDataLayer() {
        const layer = {
            event: [],
            component: [],
        };
        /* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any */
        window.digitalData = layer;
        return layer;
    }
}
